import styled from 'styled-components';

import { FontFamily, ThemeProps as Prop } from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

export const StyledImageWithAttribution = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const ImageAttributionText = styled.p`
  position: absolute;
  bottom: ${({ $bottom }) => `${$bottom}px`};
  left: ${({ $left }) => `${$left}px`};
  margin: 15px;
  color: ${() => themeUtil(Prop.CONTENT)};
  ${() => getFontStyles(FontFamily.BASE_FONT)}
  ${({ $maxWidth }) => `max-width: ${$maxWidth}`};

  .carousel-disabled & {
    display: none;
  }
`;
